/* index.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1EqgXlN91d%7Bmax-width%3A100%25%7D%0A._0jFU0VIZbP%7Bheight%3Aauto%7D");

import { useEffect, useRef } from 'react';
import { UNSAFE_useColorModeForMigration } from '@atlaskit/app-provider/use-color-mode-for-migration';
import { useThemeObserver } from '@atlaskit/tokens/use-theme-observer';
interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  /**
   * Image URL to use for dark mode. This overrides `src` when the user
   * has selected dark mode either in the app or on their operating system.
   */
  srcDark?: string;
  /**
   * A `testId` prop is provided for specified elements, which is a unique
   * string that appears as a data attribute `data-testid` in the rendered code,
   * serving as a hook for automated tests.
   */
  testId?: string;
}
const baseImageStyles = null;

/**
 * __Image__
 *
 * This component can be used interchangeably with the native `img` element. It includes additional functionality, such as theme support.
 *
 * - [Examples](https://atlassian.design/components/image/examples)
 * - [Code](https://atlassian.design/components/image/code)
 * - [Usage](https://atlassian.design/components/image/usage)
 */
export default function Image({
  src,
  srcDark,
  alt,
  testId,
  className,
  ...props
}: ImageProps): JSX.Element {
  const imgRef = useRef<HTMLImageElement>(null);
  const providedColorMode = UNSAFE_useColorModeForMigration();
  const {
    colorMode: observedColorMode
  } = useThemeObserver();
  const colorMode = providedColorMode || observedColorMode;
  useEffect(() => {
    if (imgRef === null || imgRef.current === null) {
      return;
    }
    if (srcDark && colorMode === 'dark') {
      imgRef.current.src = srcDark;
    } else if (src) {
      imgRef.current.src = src;
    }
  }, [src, srcDark, colorMode]);
  return <img alt={alt} data-testid={testId} src={src}
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
  className={ax(["_1EqgXlN91d _0jFU0VIZbP", className])} ref={imgRef}
  // The spread operator is necessary since the component can accept all the props of an `img` element.
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
  {...props} />;
}